/** Shared political party colors for forecast charts and the power index. */
export const REPUBLICAN_COLOR = '#ff3333';
export const DEMOCRATIC_COLOR = '#265cff';
